/* eslint-disable import/no-named-default */
import React from 'react';
import { default as LoaderScreen } from 'react-loader-spinner';

export default function Loader() {
    return (
        <div className="loader">
            <LoaderScreen
                color="#000"
                height={60}
                type="Oval"
                width={60}
            />
        </div>
    );
}
